import { jsx as _jsx } from "react/jsx-runtime";
import { EllipsisVertical } from "@air/next-icons";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { IconButton } from "@air/primitive-icon-button";
import { useCallback, useMemo } from "react";
export const DropdownMenuWrapper = (param)=>{
    let { options, onOpenChange, onEscapeKeyDown, dataTestId } = param;
    const handleWrapperMouseEvent = useCallback((e)=>{
        e.stopPropagation();
        e.preventDefault();
    }, []);
    const handleTriggerMouseEvent = useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const trigger = useMemo(()=>/*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            "data-testid": dataTestId,
            icon: EllipsisVertical,
            onClick: handleTriggerMouseEvent,
            onMouseDown: handleTriggerMouseEvent,
            onDoubleClick: handleTriggerMouseEvent,
            label: "More options",
            size: "medium"
        }), [
        dataTestId,
        handleTriggerMouseEvent
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        onOpenChange: onOpenChange,
        onEscapeKeyDown: onEscapeKeyDown,
        trigger: trigger,
        onClick: handleWrapperMouseEvent,
        onMouseDown: handleWrapperMouseEvent,
        children: renderDropdownItems({
            options
        })
    });
};
